import {useCallback, useEffect, useRef, useState} from 'react';

/** Coalesce incoming chunks into one display update every 40 ms. */
export function useStreamedAnswer() {
    const [text, setText] = useState('');
    const receivedText = useRef('');
    const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

    const clearTimer = useCallback(() => {
        if (timer.current !== null) {
            clearTimeout(timer.current);
            timer.current = null;
        }
    }, []);

    const flush = useCallback(() => {
        clearTimer();
        setText(receivedText.current);
    }, [clearTimer]);

    const appendToken = useCallback((token: string) => {
        if (!token) return;
        receivedText.current += token;
        if (timer.current === null) timer.current = setTimeout(flush, 40);
    }, [flush]);

    const reset = useCallback(() => {
        clearTimer();
        receivedText.current = '';
        setText('');
    }, [clearTimer]);

    useEffect(() => clearTimer, [clearTimer]);

    return {text, appendToken, flush, reset};
}
